import React, { useState, useEffect } from 'react';
import Layout from "../Layouts";
import PageHeader from "../Components/page_header";
import Sidebar from "../Components/our_team/sidebar";
import Post from "../Components/our_team/post";
import Team from "../Components/our_team";
import data from "../data/posts.json";

export default function OurTeam() {

    const [posts, setPosts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [postsPerPage, setPostsPerPage] = useState(5);
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);
    useEffect(()=>{
        const fetchPosts = async () => {
            setPosts(data.posts);
        }
        fetchPosts();
    },[]);
    const totalPosts = posts.length;
    const paginate = (e,pageNumber) => {
        setCurrentPage(pageNumber);
        window.scrollTo({ top: 400, behavior: 'smooth' });
        e.preventDefault();
    }

    return (
        <Layout>
          <PageHeader title="Our Team"/>
          <div className="section_padding">
           <Team/>
           </div>
        </Layout>
    )
}
